export default "__VITE_ASSET__e216feb4__"